import React from 'react';
import NavBar from '../NavBar/NavBar';
import './Header.css';

function Header() {
  return (
    <header className='header'>
        <NavBar />
    </header>
  );
};

export default Header;